import { v4 } from "uuid";
import { createServiceBuilder } from "./lib";
import { injectedNotificationsSlice } from "./reducer";
const { actions, selectors } = injectedNotificationsSlice;
export const NotificationsServiceBuilder = createServiceBuilder({
    name: 'NotificationsService',
    api: () => ({
        createNotification: (opts) => (dispatch) => {
            const notification = { ...opts, id: v4() };
            dispatch(actions.addNotification(notification));
            return notification;
        },
        acknowledgeNotification: actions.acknowledgeNotification,
        clearAllNotifications: actions.clearAllNotifications,
        getLatestNotification: selectors.getLatestNotification,
        removeNotification: actions.removeNotification,
        getAllNotifications: selectors.getAllNotifications,
        getNotificationByID: selectors.getNotificationById,
    }),
});
//# sourceMappingURL=NotificationsService.js.map